/**
 * Дрожь камеры поля от тяжелого удара: падение валуна катапульты, взрыв бомбы
 * гоблинов. Видят все участники матча и зрители записи — кроме витрины главного
 * меню: там партия идет фоном за кнопками, и поле не должно дергаться само по себе.
 *
 * Пока камера еще дрожит, новый вызов Phaser пропускает: валуны большого залпа
 * сливаются в один гул, а не обрывают дрожь друг друга.
 *
 * @param {Phaser.Scene} scene
 * @param {Object} shake
 * @param {number} shake.durationMs
 * @param {number} shake.intensity — доля размера кадра
 */
export const shakeFieldCamera = (scene, {durationMs, intensity}) => {
  if (!scene || scene.isDemoMode) {
    return;
  }
  scene.cameras?.main?.shake?.(durationMs, intensity);
};
